import { render, staticRenderFns } from "./vendorCouncil.vue?vue&type=template&id=2f29c3d0"
import script from "./vendorCouncil.vue?vue&type=script&lang=js"
export * from "./vendorCouncil.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f29c3d0')) {
      api.createRecord('2f29c3d0', component.options)
    } else {
      api.reload('2f29c3d0', component.options)
    }
    module.hot.accept("./vendorCouncil.vue?vue&type=template&id=2f29c3d0", function () {
      api.rerender('2f29c3d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/csm/vendorCouncil.vue"
export default component.exports